
import store from './store'
import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue'
import DefaultLayout from './layouts/Default.vue'
import DashboardLayout from './layouts/Dashboard.vue'
import DashboardRTLLayout from './layouts/DashboardRTL.vue'
import router from './router'
import 'vue-search-select/dist/VueSearchSelect.css'
// import './plugins/click-away'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import NotificationsPlugin from '@/plugins/notifications.js';

import './scss/app.scss';

Vue.use(Antd);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(NotificationsPlugin);

Vue.config.productionTip = false

// Adding template layouts to the vue components.
Vue.component("layout-default", DefaultLayout);
Vue.component("layout-dashboard", DashboardLayout);
Vue.component("layout-dashboard-rtl", DashboardRTLLayout);
// ✅ ToastAlertas solo se usa en App.vue, no necesita registro global

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// Limpiar recursos al destruir la aplicación
window.addEventListener('beforeunload', () => {
  if (window.__APP_CLEANUP_SESSION) {
    window.__APP_CLEANUP_SESSION();
  }
});

// Para desarrollo - detectar cuando se recarga con HMR
if (module.hot) {
  module.hot.dispose(() => {
    if (window.__APP_CLEANUP_SESSION) {
      window.__APP_CLEANUP_SESSION();
    }
  });
}